// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { get } from "@insite/client-framework/Services/ApiService";
import { Category, GetCategoriesApiParameter } from "@insite/client-framework/Services/CategoryService";
import {
    CategoryCollectionModel,
    CategoryModel,
} from "@insite/client-framework/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";

const categoriesUrl = "/api/v1/categories";

function cleanCategory(category: CategoryModel, categoriesById: SafeDictionary<Category>, subCategoryLevels: number) {
    const subCategories = category.subCategories;
    subCategories?.sort((a, b) => a.sortOrder - b.sortOrder || a.shortDescription.localeCompare(b.shortDescription));
    category.subCategories = null;
    const actualCategory = category as any as Category;
    if (subCategoryLevels > 0 && subCategories) {
        const subCategoryIds = [];
        for (const subCategory of subCategories) {
            subCategoryIds.push(subCategory.id);
            cleanCategory(subCategory, categoriesById, subCategoryLevels - 1);
            delete subCategory.htmlContent;
        }
        actualCategory.subCategoryIds = subCategoryIds;
    }

    categoriesById[category.id] = actualCategory;
}


export async function getCategories(parameter: GetCategoriesApiParameter) {
    const categoryCollectionModel = await get<CategoryCollectionModel>(`${categoriesUrl}/`, parameter);
    // XNG-Change
    const model = cloneDeep(categoryCollectionModel);
    const categoriesById = {};
    const categoryIds = [];
    for (const category of categoryCollectionModel.categories!) {
        categoryIds.push(category.id);
        cleanCategory(category, categoriesById, parameter.maxDepth ? parameter.maxDepth - 1 : 2);
        delete category.htmlContent;
    }

    const categoryCollection = {
        properties: categoryCollectionModel.properties,
        uri: categoryCollectionModel.uri,
        categoryIds,
        categoriesById,
    };

    // XNG-Change: send all categories as received from api along with categoryCollection
    return { categoryCollection, model };
}